import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import SettingsMenu from './SettingsMenu.jsx';
import Version from './Version.jsx';
import TrailExport from './TrailExport.jsx';

const Header = () => (
  <header
    className="w-full h-[46px] bg-[#F8F8FF]
               flex items-center justify-between px-1 mt-3"
  >
    <img
      src="/assets/Logo_Black.png"
      alt="Tarn Chat Logo"
      className="h-7 ml-2 md:ml-6"
    />

    <div className="flex items-center gap-x-4 mr-2">
      <TrailExport />

      <button
        type="button"
        className="p-2 text-gray-500 hover:text-indigo-600 focus:outline-none"
      >
        <span className="sr-only">View notifications</span>
        <BellIcon className="h-6 w-6" aria-hidden="true" />
      </button>

      <Version />
      <SettingsMenu />
    </div>
  </header>
);

export default Header;